import { styled } from "@mui/material/styles";
import ListItem from "@mui/material/ListItem";
import MuiListItemButton from "@mui/material/ListItemButton";
import Tooltip from "@mui/material/Tooltip";
import { ListItemIcon, ListItemText } from "../StyledComponents";
import { ConditionalWrapper } from "helpers/common";
import { THEME_COLORS } from "constants/theme";

const ListItemButton = styled(MuiListItemButton)(({ theme }) => ({
  paddingLeft: "8px",
  paddingRight: "8px",
  borderRadius: "4px",
  "& .add-connector-icon": {
    fontSize: "12px !important",
    marginTop: "6px",
    marginLeft: "-3px"
  },
  "&:hover": {
    backgroundColor: THEME_COLORS[theme.palette?.mode?.toUpperCase()].SELECTED_BG
  }
}));

const TitlebarActionWrapper = ({
  title,
  action,
  selected,
  nomargin,
  allowText,
  disableAction,
  children,
  ref
}) => {
  return (
    <ListItem sx={{ marginRight: nomargin ? 0 : 2 }}>
      <ListItemButton
        className="commandbar-item-btn"
        ref={ref}
        selected={selected}
        onClick={action}
        disabled={disableAction}
      >
        <ConditionalWrapper
          condition={!allowText}
          wrapper={(children) => <Tooltip title={title}>{children}</Tooltip>}
        >
          <ListItemIcon className="commandbar-icon-wrapper">{children}</ListItemIcon>
        </ConditionalWrapper>
        {allowText && <ListItemText primary={title} />}
      </ListItemButton>
    </ListItem>
  );
};

export default TitlebarActionWrapper;
